export const productFamily = [
    { ID : "IFX_CLOUD_SERVER" , Name : "CLOUD Server Credentials"},
    { ID : "OTHER" , Name : "Otro"}
];